// Reconstructed from production code; original paths and local names were not available.
import { AppLoading } from "../components/AppLoading.jsx";
import { Link } from "react-router-dom";
import { PartnersStrip } from "../components/PartnersStrip.jsx";
import { ProductCard } from "../components/ProductCard.jsx";
import React from "react";
import { Seo } from "../components/Seo.jsx";
import { api } from "../services/api.js";
import { canonicalUrl } from "../utils/seo.js";
import { hasUnknownQueryParams } from "../utils/seo.js";
import { isVideo } from "../utils/media.js";
import * as jsxRuntime from "react/jsx-runtime";
import { mediaUrl } from "../utils/media.js";
import { productImage } from "../utils/media.js";
import { siteOrigin } from "../utils/seo.js";
import { useLanguage } from "../context/LanguageContext.jsx";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { useTheme } from "../context/ThemeContext.jsx";
function isExternalUrl(l = "") {
  return /^https?:\/\//i.test(String(l || ""));
}
function localizedLabel(l, i) {
  const c = String(l || "").trim();
  if (!c) return "";
  const s = c.includes(" / ") ? " / " : c.includes(" | ") ? " | " : null;
  if (!s) return c;
  const [d = "", f = ""] = c.split(s);
  return i === "ar" ? d.trim() || f.trim() : f.trim() || d.trim();
}
function HomePage() {
  const navigate = useNavigate(),
    location = useLocation(),
    { theme: theme } = useTheme(),
    { language: language, t: t, tProd: tProd } = useLanguage(),
    [categories, setCategories] = React.useState([]),
    [slides, setSlides] = React.useState([]),
    [featuredProducts, setFeaturedProducts] = React.useState([]),
    [bestSellers, setBestSellers] = React.useState([]),
    [activeSlide, setActiveSlide] = React.useState(0),
    [videoRatios, setVideoRatios] = React.useState({}),
    [loading, setLoading] = React.useState(true),
    [showIntro, setShowIntro] = React.useState(() => {
      if (typeof window > "u") return false;
      try {
        const q =
            window.sessionStorage.getItem("storefront_intro_seen") === "1",
          Z = window.matchMedia("(max-width: 768px)").matches,
          ee = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
        return !q && !Z && !ee;
      } catch {
        return false;
      }
    }),
    introVideoRef = React.useRef(null),
    nextSlide = React.useCallback(() => {
      setActiveSlide((q) => (slides.length ? (q + 1) % slides.length : 0));
    }, [slides.length]);
  React.useEffect(() => {
    async function q() {
      try {
        const [Z, ee, ie, Ce] = await Promise.allSettled([
          api.get("/categories"),
          api.get("/slides"),
          api.get("/products/featured"),
          api.get("/products/best-sellers"),
        ]);
        Z.status === "fulfilled" && setCategories(Z.value.data || []);
        ee.status === "fulfilled" && setSlides(ee.value.data || []);
        ie.status === "fulfilled" &&
          setFeaturedProducts((ie.value.data || []).slice(0, 8));
        Ce.status === "fulfilled" &&
          setBestSellers((Ce.value.data || []).slice(0, 8));
      } catch (Z) {
        console.error(Z);
      } finally {
        setLoading(false);
      }
    }
    q();
  }, []);
  React.useEffect(() => {
    if (
      !slides.length ||
      window.matchMedia("(prefers-reduced-motion: reduce)").matches
    )
      return;
    const q = slides[activeSlide];
    if (isVideo(q?.image_url, q?.media_type)) return;
    const Z = window.setTimeout(nextSlide, 6e3);
    return () => window.clearTimeout(Z);
  }, [activeSlide, nextSlide, slides]);
  const W = () => navigate("/products"),
    te = slides[activeSlide],
    oe = isVideo(te?.image_url, te?.media_type),
    he = te ? videoRatios[te.id] : null,
    be = (q, Z) => {
      const ee = Z.currentTarget;
      if (!ee.videoWidth || !ee.videoHeight) return;
      const ie = (ee.videoWidth / ee.videoHeight).toFixed(5);
      setVideoRatios((Ce) =>
        Ce[q] === ie
          ? Ce
          : {
              ...Ce,
              [q]: ie,
            },
      );
    },
    fe = siteOrigin(),
    pe = theme?.site_name || "MyShop",
    ye = canonicalUrl(fe, "/"),
    R = hasUnknownQueryParams(location.search),
    B = language === "ar" ? "متجر المنتجات" : "Product catalog",
    F = mediaUrl(theme?.logo),
    re =
      featuredProducts.length > 0
        ? mediaUrl(productImage(featuredProducts[0]))
        : F || "",
    ge = slides.length ? mediaUrl(slides[0]?.image_url) : re || F || null,
    j =
      theme?.site_description ||
      (language === "ar"
        ? "كتالوج منتجات منظم يدعم عدة تصنيفات ومنتجات مع تجربة طلب واضحة."
        : "A structured product catalog for multiple categories with a clear ordering experience."),
    A = ye
      ? [
          {
            "@context": "https://schema.org",
            "@type": "Organization",
            "@id": `${ye}#organization`,
            name: pe,
            url: ye,
            logo: F || void 0,
            description: j,
          },
          {
            "@context": "https://schema.org",
            "@type": "WebSite",
            "@id": `${ye}#website`,
            name: pe,
            url: ye,
            description: j,
            inLanguage: language === "ar" ? "ar-TN" : "en",
            publisher: {
              "@id": `${ye}#organization`,
            },
          },
        ]
      : [],
    X = () => {
      setShowIntro(false);
      try {
        window.sessionStorage.setItem("storefront_intro_seen", "1");
      } catch {}
      introVideoRef.current && introVideoRef.current.pause();
    };
  React.useEffect(() => {
    if (!showIntro) return;
    const q = (Z) => {
      Z.key === "Escape" && X();
    };
    document.body.classList.add("intro-video-open");
    window.addEventListener("keydown", q);
    introVideoRef.current?.play().catch(() => {});
    return () => {
      document.body.classList.remove("intro-video-open");
      window.removeEventListener("keydown", q);
    };
  }, [showIntro]);
  return loading ? (
    <jsxRuntime.Fragment>
      <Seo
        title={B}
        description={j}
        image={ge}
        imageAlt={pe}
        canonicalUrl={ye || void 0}
        type={"website"}
        siteName={pe}
        language={language}
        noindex={R}
        schema={A}
      />
      <AppLoading
        variant={"page"}
        layout={"home"}
        brand={pe}
        label={
          language === "ar"
            ? "نجهّز لك تجربة تسوّق مميّزة…"
            : "Preparing your shopping experience…"
        }
        detail={
          language === "ar"
            ? "نرتّب المنتجات والتصنيفات والعروض لأجلك."
            : "Curating products, categories, and offers for you."
        }
      />
    </jsxRuntime.Fragment>
  ) : (
    <div className={"page home-page"}>
      <Seo
        title={B}
        description={j}
        image={ge}
        imageAlt={pe}
        canonicalUrl={ye || void 0}
        type={"website"}
        siteName={pe}
        language={language}
        noindex={R}
        schema={A}
      />
      {showIntro && (
        <div
          className={"intro-video-backdrop"}
          onClick={(q) => {
            q.target === q.currentTarget && X();
          }}
          role={"dialog"}
          aria-modal={"true"}
          aria-label={language === "ar" ? "فيديو تعريفي" : "Intro video"}
        >
          <div
            className={"intro-corner intro-corner-tl"}
            aria-hidden={"true"}
          />
          <div
            className={"intro-corner intro-corner-tr"}
            aria-hidden={"true"}
          />
          <div
            className={"intro-corner intro-corner-bl"}
            aria-hidden={"true"}
          />
          <div
            className={"intro-corner intro-corner-br"}
            aria-hidden={"true"}
          />
          <div className={"intro-video-box"}>
            <div className={"intro-video-header"}>
              <div className={"intro-brand-badge"}>
                <span className={"intro-brand-dot"} aria-hidden={"true"} />
                <span className={"intro-brand-name"}>{pe}</span>
              </div>
              <button
                type={"button"}
                className={"intro-video-close"}
                onClick={X}
                aria-label={language === "ar" ? "تخطّى" : "Skip"}
              >
                <span>{language === "ar" ? "تخطّى" : "Skip"}</span>
                <svg
                  width={"14"}
                  height={"14"}
                  viewBox={"0 0 14 14"}
                  fill={"none"}
                  aria-hidden={"true"}
                >
                  <path
                    d={"M1 1l12 12M13 1L1 13"}
                    stroke={"currentColor"}
                    strokeWidth={"2"}
                    strokeLinecap={"round"}
                  />
                </svg>
              </button>
            </div>
            <video
              ref={introVideoRef}
              src={"/WhatsApp Video 2026-07-06 at 11.01.09 AM.mp4"}
              className={"intro-video-player"}
              autoPlay={true}
              muted={true}
              playsInline={true}
              controls={true}
              onEnded={X}
            />
            <div className={"intro-video-footer"}>
              <div className={"intro-progress-dots"} aria-hidden={"true"}>
                <span className={"intro-dot active"} />
                <span className={"intro-dot"} />
                <span className={"intro-dot"} />
              </div>
              <span className={"intro-footer-label"}>
                {language === "ar" ? "فيديو تعريفي" : "Official introduction"}
              </span>
            </div>
          </div>
        </div>
      )}
      {slides.length > 0 ? (
        <section
          className={`hero-slider${oe ? " hero-slider--video" : ""}`}
          style={
            he
              ? {
                  "--hero-video-aspect": he,
                }
              : void 0
          }
          aria-label={
            language === "ar" ? "الواجهة الرئيسية" : "Featured collection"
          }
        >
          {slides.map((q, Z) => {
            const ee = mediaUrl(q.image_url),
              ie = (q.link_url || "").trim(),
              Ce = !!ie,
              _e = isExternalUrl(ie),
              ut = isVideo(q.image_url, q.media_type),
              gt = (
                <jsxRuntime.Fragment>
                  {ut ? (
                    Z === activeSlide ? (
                      <video
                        src={ee}
                        className={"hero-slide-video"}
                        autoPlay={true}
                        muted={true}
                        playsInline={true}
                        controls={true}
                        preload={"metadata"}
                        onEnded={nextSlide}
                        onLoadedMetadata={(At) => be(q.id, At)}
                      />
                    ) : null
                  ) : (
                    <img
                      src={ee}
                      alt={localizedLabel(q.title, language) || pe}
                      loading={Z === 0 ? "eager" : "lazy"}
                      fetchPriority={Z === 0 ? "high" : "low"}
                      decoding={"async"}
                    />
                  )}
                </jsxRuntime.Fragment>
              );
            return (
              <div
                className={"hero-slide" + (Z === activeSlide ? " active" : "")}
                key={q.id}
              >
                {Ce ? (
                  _e ? (
                    <a href={ie} className={"hero-slide-link"}>
                      {gt}
                    </a>
                  ) : (
                    <Link to={ie} className={"hero-slide-link"}>
                      {gt}
                    </Link>
                  )
                ) : (
                  gt
                )}
              </div>
            );
          })}
          <div className={"hero-dots"}>
            {slides.map((q, Z) => (
              <button
                className={"hero-dot" + (Z === activeSlide ? " active" : "")}
                aria-label={
                  language === "ar" ? `الشريحة ${Z + 1}` : `Slide ${Z + 1}`
                }
                aria-current={Z === activeSlide ? "true" : void 0}
                onClick={() => setActiveSlide(Z)}
                key={Z}
              />
            ))}
          </div>
        </section>
      ) : (
        <section
          className={"hero-static"}
          dir={language === "ar" ? "rtl" : "ltr"}
        >
          {re && (
            <img
              className={"hero-static-bg"}
              src={re}
              alt={""}
              aria-hidden={"true"}
              loading={"eager"}
              decoding={"async"}
            />
          )}
          <div className={"hero-static-content"}>
            <span className={"hero-kicker"}>{pe}</span>
            <h1 className={"hero-static-title"}>{t("heroTitle")}</h1>
            <p className={"hero-static-subtitle"}>{t("heroSubtitle")}</p>
            <div className={"hero-trust-row hero-static-trust-row"}>
              <span>
                {language === "ar" ? "تصنيفات متعددة" : "Multiple categories"}
              </span>
              <span>
                {language === "ar" ? "منتجات متنوعة" : "Flexible catalog"}
              </span>
              <span>{language === "ar" ? "طلب واضح" : "Clear ordering"}</span>
            </div>
            <div className={"hero-actions"}>
              <button type={"button"} className={"btn hero-btn"} onClick={W}>
                {t("shopNow")}
              </button>
              <button
                type={"button"}
                className={"hero-secondary-btn"}
                onClick={W}
              >
                {t("allProducts")}
              </button>
            </div>
          </div>
        </section>
      )}
      {categories.length > 0 && (
        <section
          className={"home-categories"}
          id={"home-categories"}
          aria-labelledby={"home-categories-heading"}
        >
          <div className={"home-categories-head"}>
            <div>
              <span className={"section-kicker"}>
                {language === "ar" ? "تصفّح" : "Browse"}
              </span>
              <h2 id={"home-categories-heading"}>{t("categories")}</h2>
              <p>{t("categoriesDesc")}</p>
            </div>
            <button
              type={"button"}
              className={"home-categories-all"}
              onClick={W}
            >
              {t("allProducts")}
            </button>
          </div>
          <div className={"home-categories-grid"}>
            {categories.map((q) => {
              const Z = mediaUrl(q.image_url);
              return (
                <article
                  className={
                    "home-category-card" +
                    (Z ? "" : " home-category-card--placeholder")
                  }
                  key={q.id}
                >
                  <Link
                    to={`/category/${q.slug}`}
                    className={"home-category-main-link"}
                  >
                    <div className={"home-category-img"}>
                      {Z ? (
                        <img
                          src={Z}
                          alt={tProd(q.name, q, "name")}
                          loading={"lazy"}
                          decoding={"async"}
                        />
                      ) : (
                        <div
                          className={"home-category-img-placeholder"}
                          aria-hidden={"true"}
                        >
                          {tProd(q.name, q, "name")?.slice(0, 2)}
                        </div>
                      )}
                    </div>
                    <div className={"home-category-body"}>
                      <div className={"home-category-title"}>
                        {tProd(q.name, q, "name")}
                      </div>
                      <p className={"home-category-count"}>
                        {(q.subcategories || []).length || 1}{" "}
                        {language === "ar"
                          ? (q.subcategories || []).length > 1
                            ? "تصنيفات فرعية"
                            : "تصنيف فرعي"
                          : "Subcategories"}
                      </p>
                    </div>
                  </Link>
                  <div className={"home-category-submenu"}>
                    <div className={"home-submenu-title"}>
                      {t("viewCategory")}
                    </div>
                    <Link
                      to={`/category/${q.slug}`}
                      className={"home-submenu-all"}
                    >
                      {t("viewAll")}
                    </Link>
                  </div>
                </article>
              );
            })}
          </div>
        </section>
      )}
      {featuredProducts.length > 0 && (
        <section
          className={"home-featured-section"}
          aria-labelledby={"home-featured-heading"}
        >
          <div className={"home-categories-head"}>
            <div>
              <span className={"section-kicker"}>{t("newArrivals")}</span>
              <h2 id={"home-featured-heading"}>{t("featuredProducts")}</h2>
              <p>{t("featuredDesc")}</p>
            </div>
            <button
              type={"button"}
              className={"home-categories-all"}
              onClick={W}
            >
              {t("viewStore")}
            </button>
          </div>
          <div className={"product-grid home-featured-grid"}>
            {featuredProducts.map((q, Z) => (
              <ProductCard product={q} priority={Z < 2} key={q.id} />
            ))}
          </div>
        </section>
      )}
      {bestSellers.length > 0 && (
        <section
          className={"home-featured-section home-best-selling-section"}
          aria-labelledby={"home-best-selling-heading"}
        >
          <div
            className={"home-categories-head"}
            id={"home-best-selling-heading"}
          >
            <div>
              <span className={"section-kicker"}>
                {language === "ar" ? "المنتجات المفضلة" : "Most requested"}
              </span>
              <h2>
                {language === "ar"
                  ? "المنتجات الأكثر مبيعاً"
                  : "Best-selling products"}
              </h2>
              <p>
                {language === "ar"
                  ? "اختيارات الإدارة والمنتجات الأكثر مبيعاً من طلبات الحرفاء."
                  : "Chosen manually by the admin and completed from confirmed customer orders."}
              </p>
            </div>
            <button
              type={"button"}
              className={"home-categories-all"}
              onClick={W}
            >
              {t("viewStore")}
            </button>
          </div>
          <div className={"product-grid home-featured-grid"}>
            {bestSellers.map((q, Z) => (
              <ProductCard product={q} priority={Z < 2} key={q.id} />
            ))}
          </div>
        </section>
      )}
      <PartnersStrip />
    </div>
  );
}
export { isExternalUrl, localizedLabel, HomePage };
